var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#EEE6FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 15.1787C43.1131 15.1787 36.3808 17.221 30.6544 21.0472C24.9281 24.8734 20.4649 30.3118 17.8293 36.6746C15.1938 43.0373 14.5042 50.0388 15.8478 56.7935C17.1914 63.5482 20.5078 69.7527 25.3777 74.6226C30.2476 79.4925 36.4521 82.8089 43.2068 84.1525C49.9615 85.4961 56.963 84.8065 63.3257 82.1709C69.6885 79.5354 75.1269 75.0722 78.9531 69.3459C82.7793 63.6195 84.8216 56.8872 84.8216 50.0001C84.8118 40.7679 81.14 31.9166 74.6119 25.3884C68.0837 18.8603 59.2324 15.1885 50.0002 15.1787ZM65.2881 43.8595L46.5381 62.6095C46.2893 62.8586 45.9939 63.0561 45.6687 63.1909C45.3436 63.3257 44.995 63.3951 44.643 63.3951C44.291 63.3951 43.9424 63.3257 43.6173 63.1909C43.2921 63.0561 42.9967 62.8586 42.7479 62.6095L34.7122 54.5738C34.2096 54.0712 33.9272 53.3895 33.9272 52.6787C33.9272 51.9679 34.2096 51.2862 34.7122 50.7836C35.2148 50.281 35.8965 49.9986 36.6073 49.9986C37.3181 49.9986 37.9998 50.281 38.5024 50.7836L44.643 56.9276L61.4979 40.0693C61.7468 39.8205 62.0422 39.6231 62.3674 39.4884C62.6926 39.3537 63.0411 39.2844 63.393 39.2844C63.745 39.2844 64.0935 39.3537 64.4186 39.4884C64.7438 39.6231 65.0392 39.8205 65.2881 40.0693C65.537 40.3182 65.7344 40.6136 65.8691 40.9388C66.0037 41.264 66.0731 41.6125 66.0731 41.9644C66.0731 42.3164 66.0037 42.6649 65.8691 42.99C65.7344 43.3152 65.537 43.6106 65.2881 43.8595Z",
    fill: "#5604F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/CheckCircle.cacebc779b46468ad975f97247a8bead.svg";
export { ForwardRef as ReactComponent };